export function formatTimestamp(timestamp: { seconds: bigint; nanos: number } | undefined) {
  if (!timestamp) return '-';
  const date = new Date(Number(timestamp.seconds) * 1000 + timestamp.nanos / 1000000);
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}

export function formatTimestampISO(timestamp: string | undefined) {
  if (!timestamp) return '-';
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) return '-';
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}

export function formatLatency(latency: number | undefined) {
  if (latency === undefined || latency === 0) return '-';
  if (latency < 1000) return `${latency.toFixed(0)}ms`;
  if (latency < 60000) return `${(latency / 1000).toFixed(1)}s`;
  return `${(latency / 60000).toFixed(1)}m`;
}

export function parseMarkdown(text: string): string {
  let html = text
    .replace(/\\n/g, '\n')
    .replace(/\\u003e/g, '>')
    .replace(/\\u003c/g, '<')
    .replace(/\\"/g, '"')
    .replace(/\\\\/g, '\\')
    .replace(
      /```(\w*)\n?([\s\S]*?)```/g,
      '<pre class="bg-muted rounded p-3 my-3 overflow-x-auto text-sm"><code>$2</code></pre>'
    )
    .replace(
      /`([^`]+)`/g,
      '<code class="bg-muted px-1.5 py-0.5 rounded text-xs font-mono">$1</code>'
    )
    .replace(/\*\*([^*]+)\*\*/g, '<strong class="font-bold">$1</strong>')
    .replace(/\*([^*]+)\*/g, '<em class="italic">$1</em>')
    .replace(/^### (.+)$/gm, '<h3 class="text-sm font-semibold mt-4 mb-2">$1</h3>')
    .replace(/^## (.+)$/gm, '<h2 class="text-base font-semibold mt-4 mb-2">$1</h2>')
    .replace(/^# (.+)$/gm, '<h1 class="text-lg font-bold mt-4 mb-2">$1</h1>')
    .replace(/^\| (.+) \|$/gm, (match) => {
      const cells = match.split('|').filter((c) => c.trim());
      const isHeader = cells.some((c) => c.includes('---'));
      if (isHeader) return '';
      return (
        '<tr>' +
        cells.map((c) => `<td class="border px-2 py-1">${c.trim()}</td>`).join('') +
        '</tr>'
      );
    })
    .replace(/(<tr>.*<\/tr>)/gs, '<table class="w-full border-collapse my-3 text-sm">$1</table>')
    .replace(/^- (.+)$/gm, '<li class="ml-4 list-disc">$1</li>')
    .replace(/\n{2,}/g, '</p><p class="my-3">')
    .replace(/\n/g, '<br/>');

  html = '<p class="my-3">' + html + '</p>';
  html = html.replace(/<p class="my-3"><br\/>/g, '<p class="my-3">');
  html = html.replace(/<br\/><\/p>/g, '</p>');

  return html;
}
